import * as types from '../mutation-types'
import requester from '@ibkr/web.app.request.util';

const isDev = $build.mode == 'development';

const state = {
    abFeatures: {},
}

const getters = {
    abFeatures: state => {
        return state.abFeatures;
    },

    showDirectHMDS: (state, localGetters, rootState, rootGetters) => {
        const features = state.abFeatures;
        return isDev || (features && (features['DIRECT_HMDS'] === 1)) || false;
    },

    showDirectMD: (state, localGetters, rootState, rootGetters) => {
        const features = state.abFeatures;
        return isDev || (features && (features['DIRECT_MD'] === 1)) || false;
    },

    useNewSsodhAuth: (state, localGetters) => {
        const features = state.abFeatures;
        return (features && (features['NEW_SSODH_AUTH'] === 1)) || false;
    },

    showContextHelp: (state, localGetters, rootState, rootGetters) => {
        const features = state.abFeatures;
        return rootGetters.isAlphaEnv || (!rootGetters.wbId && features && features['SHOW_CONTEXTUAL_HELP'] === 1) || false;
    },

    showAds: (state, localGetters, rootState, rootGetters) => {
        const features = state.abFeatures;
        return (!rootGetters.wbId && features && features['show2020Ads'] === '1') || false;
    },

    showIAWidget: (state) => {
        const features = state.abFeatures;
        return (features && (features['SHOW_IA_WIDGET'] === 1)) || false;
    },

    showSearchableNews: (state, localGetters, rootState, rootGetters) => {
        return isDev || (state.abFeatures?.USE_CP_SEARCHABLE_NEWS === 1);
    },

    showEDDWarn: (state, localGetters, rootState, rootGetters) => {
        const features = state.abFeatures;
        return isDev || (features && (features['SHOW_EDD_WARN'] === 1)) || false;
    },

    showRestrictedNotice: (state, localGetters, rootState, rootGetters) => {
        return (isDev || rootGetters.isAlphaEnv || (state.abFeatures?.NOEXTCLSPOS === 1));
    },

    showSuggestedSizeReject: (state, localGetters, rootState, rootGetters) => {
        return (isDev || rootGetters.isAlphaEnv || (state.abFeatures?.CP_SHOW_SUGGESTED_SIZE_REJECT === 1));
    },

    showCrypto: (state, localGetters, rootState, rootGetters) => {
        return (rootGetters.protectProd || (state.abFeatures?.ALLOW_CRYPTO === 1));
    },

    showCryptoAds: (state, localGetters, rootState, rootGetters) => {
        return (rootGetters.protectProd || (state.abFeatures?.SHOW_CRYPTO_ADS === 1));
    },

    enableWidescreen: (state, localGetters, rootState, rootGetters) => {
        return (rootGetters.protectProd || (state.abFeatures?.WIDE_UX === 1));
    },

    showExitStrategy: (state, localGetters, rootState, rootGetters) => {
        return (rootGetters.protectProd || (state.abFeatures?.SHOW_EXIT_STRATEGY === 1));
    },

    showFinLens: (state, localGetters, rootState, rootGetters) => {
        return (rootGetters.protectProd || (state.abFeatures?.SHOW_FINANCIAL_LENS === 1));
    },

    showOptionExercise: (state, localGetters, rootState, rootGetters) => {
        return (rootGetters.protectProd || (state.abFeatures?.SHOW_OPTION_EXERCISE === 1));
    },

    useMdFarmRegsnapshot: (state, localGetters, rootState, rootGetters) => {
        return (rootGetters.protectProd || (state.abFeatures?.MD_FARM_REGSNAPSHOT === 1));
    },

    useNewPnl: (state, localGetters, rootState, rootGetters) => {
        return (isDev || (state.abFeatures?.NEW_PNL === 1));
    }

}

const mutations = {
    [types.SET_AB_FEATURES](state, data) {
        state.abFeatures = data;
    }
}

const actions = {

    getCPABFeatures({ commit }) {
        const cpEnv = (window.env ? `${window.env}` : `V1`).toUpperCase();
        const body = {
            "type": "featuresMsg",
            "datetime": new Date().toISOString(),
            "context": {
                "applicationId": "CP",
                "features": {
                    "SHOW_CONTEXTUAL_HELP": 0,
                    "DIRECT_HMDS": 0,
                    "DIRECT_MD": 0,
                    "NEW_PNL": 0,
                    "NEW_SSODH_AUTH": 0,
                    "SHOW_IA_WIDGET": 0,
                    "USE_CP_SEARCHABLE_NEWS": 0,
                    "SHOW_EDD_WARN": 0,
                    "NOEXTCLSPOS": 0,
                    "CP_SHOW_SUGGESTED_SIZE_REJECT": 0,
                    "ALLOW_CRYPTO": 0,
                    "SHOW_CRYPTO_ADS": 0,
                    "WIDE_UX": 0,
                    "SHOW_EXIT_STRATEGY": 0,
                    "SHOW_FINANCIAL_LENS": 0,
                    "SHOW_OPTION_EXERCISE": 0,
                    "MD_FARM_REGSNAPSHOT": 0
                },
                "applicationFilters": {
                    "env": cpEnv
                }
            }
        }
        return new Promise((resolve, reject) => {
            requester.request(`abtesting/features/CP`, {
                method: 'POST',
                body: JSON.stringify(body)
            })
            .then((r) => r.json())
            .then((json) => {
                if (json && json.context && json.context.features) {
                    commit(types.SET_AB_FEATURES, json.context.features);
                }
                resolve();
            })
            .catch((e) => {
                reject(e);
            })
        });
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
